import './BubbleFeature.pcss';
import React from 'react';
import { BubbleFeatureObject } from '../../constants';

type Props = {
  feature: BubbleFeatureObject;
};

export const BubbleFeature = ({ feature }: Props) => {
  const { bubbleValue, text } = feature;

  return (
    <div className="bubble-feature">
      <div className="bubble-feature__bubble">{bubbleValue}</div>

      <div className="bubble-feature__right-text">{text}</div>
    </div>
  );
};
